export enum RadioPlayerStatus {
    Stopped,
    Buffering,
    Playing
}